import mainTemplate from './index.hbs';

export function getMarkup(data) {
  return mainTemplate(data).trim();
}

export default getMarkup;
